import { useQuery } from '@tanstack/react-query';

import { courseConst, ITeacher } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getTopTeachers = (limit?: number) => async () => {
  const { data } = await $apiV2.get(`/teacher/top`, { params: { limit } });

  return { topTeachers: data?.data };
};

export const useTopTeachers = (limit: number = 6) => {
  const { data, ...args } = useQuery<{ topTeachers: ITeacher[] }>({
    queryKey: [courseConst.queryKeys.TOP_TEACHERS, limit],
    queryFn: getTopTeachers(limit)
  });

  return { ...data, ...args };
};
